import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Test from "./Test"
import NavMenu from "./NavMenu"


function NotFound() {
  return <h2>Not found</h2>;
}


export default function App() {
  return (
    <div>
      <Router>
              <div>
          <Switch>
            <Route exact path="/" component={NavMenu} />
            <Route exact path="/test" component={Test} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    
    </div>
  );
}
